const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.9892 10.8775L3.36264 13.2166L1.07259 13.265C0.388197 11.9956 0 10.5433 0 8.99988C0 7.50746 0.362955 6.10007 1.00632 4.86084H1.00681L3.0456 5.23462L3.93871 7.26118C3.75179 7.80615 3.6499 8.39115 3.6499 8.99988C3.64997 9.66054 3.76964 10.2935 3.9892 10.8775Z",
  fill: "#FBBB00"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8427 7.3186C17.9461 7.86303 18 8.42529 18 8.99991C18 9.64426 17.9323 10.2728 17.8032 10.879C17.3651 12.9421 16.2203 14.7436 14.6344 16.0184L14.6339 16.0179L12.066 15.8869L11.7025 13.6181C12.7548 13.001 13.5772 12.0352 14.0104 10.879H9.19788V7.3186H14.0806H17.8427Z",
  fill: "#518EF8"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6338 16.0181L14.6343 16.0186C13.092 17.2583 11.1327 18.0001 8.99994 18.0001C5.57252 18.0001 2.59263 16.0844 1.07251 13.2652L3.98911 10.8777C4.74916 12.9061 6.70592 14.3501 8.99994 14.3501C9.98597 14.3501 10.9097 14.0836 11.7024 13.6182L14.6338 16.0181Z",
  fill: "#28B446"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7447 2.07197L11.8291 4.45895C11.0087 3.94616 10.039 3.64993 9.00003 3.64993C6.65409 3.64993 4.66073 5.16014 3.93876 7.26133L1.00684 4.86099H1.00635C2.50421 1.97308 5.52167 0 9.00003 0C11.1838 0 13.186 0.777869 14.7447 2.07197Z",
  fill: "#F14336"
});
function SvgGoogleLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google_logo.df7a6de2.svg";
export { ForwardRef as ReactComponent };